import { AUFTRAG_API } from '@Constants/backendConstants';
import { type ApiRequisition } from '@Model';
import {
    FrameEditBase,
    useFrameEditBaseNavigation,
    type IFrameEditShellProps,
} from '@synqo/frontend-component-library';
import { useParams } from 'react-router';
import { useHasPermission } from '@Contexts/appContext';
import { Permission } from '@Constants/Permission.g';
import { RequisitionDetail } from './RequisitionDetail';

/**
 * The route a requisition opens under.
 *
 * Everyone sees the same thing: a requisition is never edited through a mask. A customer places
 * one in the wizard, an operator records an order that is backfilled into one, and from then on it
 * is read-only for both — which is why there is no operator variant of this frame.
 */
// @ai-generated 2026-05-28T13:00:50+00:00 by matthias.gessinger@synqony.com using Claude Opus 4.7
export function FrameEditRequisition(props: IFrameEditShellProps<ApiRequisition>) {
    const hasPermission = useHasPermission();
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    return (
        <FrameEditBase<ApiRequisition>
            key={primaryKey}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
            apiResourcePath={`${AUFTRAG_API}/requisitions`}
            renderer={RequisitionDetail}
            canEdit={false}
            canCreate={hasPermission(Permission.AuftragsbearbeitungRequisitionsCreate)}
            canDelete={false}
            frameProps={{
                events: {
                    ...frameEditBaseNavigationEvents,
                    ...props.events,
                },
            }}
        />
    );
}
